import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'pages.rewards.header',
    defaultMessage: '<strong>Rewards</strong> &amp; <strong>Payments</strong>',
  },
  table1Td1: {
    id: 'pages.rewards.table1Td1',
    defaultMessage: 'Volume of sales < 1000$',
  },
  table1Td2: {
    id: 'pages.rewards.table1Td2',
    defaultMessage: 'Volume of sales > 1000$',
  },
  table1Td3: {
    id: 'pages.rewards.table1Td3',
    defaultMessage: '10% on the wholesale price sale of each Standard or Inventory name, but no less than 1,5$ and no more than 50$',
  },
  table1Td4: {
    id: 'pages.rewards.table1Td4',
    defaultMessage: '20% on the wholesale price sale of each Standard or Inventory name, but no less than 2,25$ and no more than 100$',
  },
  table1Td5: {
    id: 'pages.rewards.table1Td5',
    defaultMessage: '* The wholesale price of all domain names identifies above shall be determined by UKCI and excludes VAT or any other applicable sales taxes.<br>* Retail prices or all domain names identified above are only applicable for first-year registrations.',
  },
  exceptions: {
    id: 'pages.rewards.exceptions',
    defaultMessage: 'Exceptions',
  },
  exceptionsText1: {
    id: 'pages.rewards.exceptionsText1',
    defaultMessage: 'If you represent an art-related institution with a significant database and expect your sales volumes to exceed those specified in the table above, please contact us to discuss exclusive offer conditions.',
  },
  exceptionsText2: {
    id: 'pages.rewards.exceptionsText2',
    defaultMessage: 'If from your website, using advertising link existing referral of another party referral program will make order, according to the order you will be transfered to 1/2 of relying.',
  },
  exceptionsText3: {
    id: 'pages.rewards.exceptionsText3',
    defaultMessage: 'If your referral will use to order the advertising link of another party referral program an make an order, according to the order you will be transfered to 1/2 of relying remuneration.',
  },
  exceptionsText4: {
    id: 'pages.rewards.exceptionsText4',
    defaultMessage: 'Transactions in the domain stores do not participate in the referral program.',
  },
  attention: {
    id: 'pages.rewards.attention',
    defaultMessage: 'Attention',
  },
  attentionText: {
    id: 'pages.rewards.attentionText',
    defaultMessage: 'Our affiliates are expected to represent the .ART brand in a way consonant with our mission to serve the art community, encourage innovation and create community dialogue.',
  },
});



// WEBPACK FOOTER //
// ./src/pages/RewardsPage/messages.js